import React from 'react';
import classnames from 'classnames';
import PopoverOnHover from '../../../Popover/PopoverOnHover';
import Who from '../../../Who';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import s from './Stats.scss';
var WhoTooltipWrapper = function (_a) {
    var deviation = _a.deviation, userListType = _a.userListType, tooltipDataHook = _a.tooltipDataHook, dataHook = _a.dataHook, children = _a.children;
    var noHover = [
        DeviationTypes.COMMISSION,
        DeviationTypes.STATUS,
        DeviationTypes.POLL,
    ].includes(getDeviationType(deviation));
    if (noHover) {
        return (React.createElement("span", { className: s['stat'], "data-hook": dataHook }, children));
    }
    return (React.createElement("span", { className: classnames(s['stat'], s['hoverable']), "data-hook": dataHook },
        React.createElement(PopoverOnHover, { renderInnerContent: function (_a) {
                var scheduleUpdate = _a.scheduleUpdate;
                return (React.createElement(Who, { deviation: deviation, userListType: userListType, scheduleTooltipUpdate: scheduleUpdate, dataHook: tooltipDataHook }));
            }, directionalClassNames: {
                top: s['tooltip-top'],
                bottom: s['tooltip-bottom'],
            }, className: s['tooltip-wrapper'], hideOnScroll: false, usePortal: false, positionOnly: true }, children)));
};
WhoTooltipWrapper.displayName = 'WhoTooltipWrapper';
export default WhoTooltipWrapper;
//# sourceMappingURL=WhoTooltipWrapper.js.map